export const selectFocusedRecording = (state) => {
  const index = state.recordings.focusedRecordingIndex;
  return state.recordings.recordings[index];
};